import { FC } from "react";
import { Stack, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CaretArrowSvg from "@/assets/svg/CaretArrowSvg";
import { useNavigate } from "react-router-dom";

interface IMenuItem {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  link?: string;
  onClick?: () => void;
}

interface MenuItemCardProps {
  item: IMenuItem;
  active?: boolean;
}

const MenuItemCard: FC<MenuItemCardProps> = ({ item, active = false }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const handleClick = () => {
    if (item.link) navigate(item.link);
    if (item.onClick) item.onClick();
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onClick={handleClick}
      sx={{
        minHeight: "52px",
        padding: "0 16px",
        cursor: "pointer",
        backgroundColor: active ? "#F9FCFE" : "#fff",
        borderRight: active ? "2px solid #2A85FF" : "2px solid transparent",
        "&:hover": {
          backgroundColor: "#F9FCFE",
        },
      }}
    >
      <Stack direction="row" alignItems="center" gap="0.5rem">
        {item.icon && <Box>{item.icon}</Box>}
        <Box>
          <Typography
            color={theme.palette.custom.blueGray900}
            fontWeight={600}
            variant="h6"
            lineHeight="1.5rem"
          >
            {item.title}
          </Typography>
          {item.subtitle && (
            <Typography
              color={theme.palette.custom.blueGray600}
              lineHeight="0.875rem"
              fontWeight={500}
              variant="body2"
              fontSize="12px"
            >
              {item.subtitle}
            </Typography>
          )}
        </Box>
      </Stack>

      <CaretArrowSvg height={24} width={24} />
    </Stack>
  );
};

export default MenuItemCard;
